/**
 * Parses a user agent string to extract the browser name.
 * Returns the browser name if identifiable, otherwise returns null.
 *
 * @param userAgent - The user agent string to parse.
 * @returns The browser name (e.g., "Chrome", "Firefox", "Safari") or null if not identifiable.
 */
export function parseUserAgent(userAgent: string | null | undefined): string | null {
  if (!userAgent || typeof userAgent !== 'string') {
    return null
  }

  const ua = userAgent.toLowerCase()

  // Edge (must check before Chrome)
  if (ua.includes('edg')) {
    return 'Edge'
  }

  // Opera (must check before Chrome)
  if (ua.includes('opr') || ua.includes('opera')) {
    return 'Opera'
  }

  // Brave (must check before Chrome since Brave includes Chrome in its UA)
  if (ua.includes('brave')) {
    return 'Brave'
  }

  // Chrome (must check before Safari since Chrome includes Safari in its UA)
  if (ua.includes('chrome') && !ua.includes('edg') && !ua.includes('opr') && !ua.includes('samsung')) {
    return 'Chrome'
  }

  // Firefox
  if (ua.includes('firefox')) {
    return 'Firefox'
  }

  // Safari (must check after Chrome since Chrome includes Safari in its UA)
  if (ua.includes('safari') && !ua.includes('chrome')) {
    return 'Safari'
  }

  // Samsung Internet
  if (ua.includes('samsung')) {
    return 'Samsung Internet'
  }

  // Internet Explorer
  if (ua.includes('msie') || ua.includes('trident')) {
    return 'Internet Explorer'
  }

  // Vivaldi
  if (ua.includes('vivaldi')) {
    return 'Vivaldi'
  }

  // If no browser is identified, return null
  return null
}

